export default "__VITE_ASSET__ja4V25BN__"